<template>
    <div class="flex w-full">
        <div class="ml-auto mr-3 flex space-x-2">
            <button
                v-if="showBackButton"
                class="flex items-center justify-center rounded-lg border border-theme-button-border bg-theme-button-bg px-3 py-1.5 text-theme-text hover:opacity-80 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                @click="$emit('prev')"
            >
                <span>{{ localizations[lang].onboarding.previous }}</span>
            </button>

            <button
                dusk="nextStep"
                class="flex items-center justify-center rounded-lg bg-theme-buynow-bg px-3 py-1.5 text-theme-buynow-text hover:opacity-90 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                @click="$emit('next')"
            >
                <span>{{
                    isLastStep ? localizations[lang].onboarding.finish : localizations[lang].onboarding.next
                }}</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewNavigationButtons',
    props: {
        showBackButton: {
            type: Boolean,
            default: true,
        },
        isLastStep: {
            type: Boolean,
            default: false,
        },
        localizations: {
            type: Object,
            required: true,
        },
        lang: {
            type: String,
            required: true,
        },
    },
    emits: ['prev', 'next'],
};
</script>
